export const waveSvgs = {
  'dark-to-light': (
    <svg viewBox="0 0 1440 200" preserveAspectRatio="none">
      <defs>
        <linearGradient id="w1g1" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%" stopColor="#0D2818" />
          <stop offset="50%" stopColor="#142e20" />
          <stop offset="100%" stopColor="#0D2818" />
        </linearGradient>
        <linearGradient id="w1g2" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%" stopColor="#1B4332" />
          <stop offset="100%" stopColor="#0D2818" />
        </linearGradient>
      </defs>
      <path d="M0,0 L0,120 Q180,200 360,140 Q540,80 720,130 Q900,180 1080,110 Q1260,40 1440,100 L1440,0Z" fill="url(#w1g1)" />
      <path d="M0,0 L0,80 Q240,180 480,100 Q720,20 960,90 Q1200,160 1440,60 L1440,0Z" fill="url(#w1g2)" opacity=".5" />
      <path d="M0,0 L0,50 Q360,160 720,80 Q1080,-10 1440,70 L1440,0Z" fill="#1B4332" opacity=".3" />
      <path d="M0,40 Q200,100 400,50 Q600,0 800,40 Q1000,80 1200,30 Q1400,-10 1440,20" fill="none" stroke="rgba(82,183,136,.12)" strokeWidth="1.5" />
      <path d="M0,70 Q300,130 600,60 Q900,-10 1200,50 Q1350,80 1440,40" fill="none" stroke="rgba(176,125,59,.08)" strokeWidth="1" />
    </svg>
  ),

  'light-to-sand': (
    <svg viewBox="0 0 1440 160" preserveAspectRatio="none">
      <defs>
        <linearGradient id="w2g1" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#FFFDF7" />
          <stop offset="100%" stopColor="#FAF8F4" />
        </linearGradient>
      </defs>
      <path d="M0,0 L0,100 Q120,160 240,120 Q480,60 720,110 Q960,160 1200,90 Q1380,40 1440,80 L1440,0Z" fill="url(#w2g1)" />
      <path d="M0,0 L0,60 Q360,140 720,60 Q1080,-20 1440,50 L1440,0Z" fill="#FFFDF7" opacity=".6" />
      <path d="M0,30 Q240,110 480,50 Q720,-10 960,40 Q1200,90 1440,20" fill="none" stroke="rgba(64,145,108,.08)" strokeWidth="1.5" />
    </svg>
  ),

  'sand-to-light': (
    <svg viewBox="0 0 1440 180" preserveAspectRatio="none">
      <defs>
        <linearGradient id="w3g1" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%" stopColor="#FAF8F4" />
          <stop offset="50%" stopColor="#F5F0E8" />
          <stop offset="100%" stopColor="#FAF8F4" />
        </linearGradient>
      </defs>
      <path d="M0,0 L0,130 Q180,180 360,120 Q540,60 720,110 Q900,160 1080,100 Q1260,50 1440,90 L1440,0Z" fill="url(#w3g1)" />
      <path d="M0,0 L0,70 Q240,150 480,80 Q720,10 960,70 Q1200,140 1440,40 L1440,0Z" fill="#FAF8F4" opacity=".7" />
      <path d="M0,0 L0,40 Q480,130 960,30 Q1200,-20 1440,50 L1440,0Z" fill="#FAF8F4" opacity=".4" />
      <path d="M0,60 Q360,130 720,50 Q1080,-30 1440,60" fill="none" stroke="rgba(64,145,108,.06)" strokeWidth="2" />
    </svg>
  ),

  'light-to-dark': (
    <svg viewBox="0 0 1440 260" preserveAspectRatio="none">
      <defs>
        <linearGradient id="w4g2" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#FFFDF7" />
          <stop offset="100%" stopColor="#F5F0E8" />
        </linearGradient>
      </defs>
      <rect width="1440" height="260" fill="#0D2818" />
      <path d="M0,0 L0,200 Q180,260 360,190 Q540,120 720,180 Q900,240 1080,160 Q1260,80 1440,150 L1440,0Z" fill="url(#w4g2)" />
      <path d="M0,0 L0,150 Q240,240 480,150 Q720,60 960,140 Q1200,220 1440,100 L1440,0Z" fill="#FFFDF7" opacity=".6" />
      <path d="M0,0 L0,100 Q360,200 720,100 Q1080,0 1440,80 L1440,0Z" fill="#FFFDF7" opacity=".35" />
      <path d="M0,0 L0,60 Q480,150 960,50 Q1200,-10 1440,40 L1440,0Z" fill="#FFFDF7" opacity=".15" />
      <path d="M0,120 Q200,180 400,110 Q600,40 800,100 Q1000,160 1200,80 Q1400,10 1440,50" fill="none" stroke="rgba(82,183,136,.08)" strokeWidth="2" />
    </svg>
  ),

  'dark-to-sand': (
    <svg viewBox="0 0 1440 260" preserveAspectRatio="none">
      <defs>
        <linearGradient id="w5g1" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%" stopColor="#0D2818" />
          <stop offset="30%" stopColor="#142e20" />
          <stop offset="70%" stopColor="#1B4332" />
          <stop offset="100%" stopColor="#0D2818" />
        </linearGradient>
        <linearGradient id="w5g2" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#0D2818" />
          <stop offset="100%" stopColor="#1B4332" />
        </linearGradient>
      </defs>
      <path d="M0,0 L0,200 Q240,260 480,180 Q720,100 960,170 Q1200,240 1440,140 L1440,0Z" fill="url(#w5g1)" />
      <path d="M0,0 L0,160 Q180,240 360,160 Q540,80 720,140 Q900,200 1080,120 Q1260,40 1440,100 L1440,0Z" fill="url(#w5g2)" opacity=".7" />
      <path d="M0,0 L0,110 Q360,190 720,100 Q1080,10 1440,80 L1440,0Z" fill="#0D2818" opacity=".5" />
      <path d="M0,100 Q240,170 480,90 Q720,10 960,80 Q1200,150 1440,60" fill="none" stroke="rgba(82,183,136,.1)" strokeWidth="2" />
    </svg>
  ),

  'sand-to-dark': (
    <svg viewBox="0 0 1440 240" preserveAspectRatio="none">
      <defs>
        <linearGradient id="w6g1" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#FAF8F4" />
          <stop offset="50%" stopColor="#FAF8F4" stopOpacity=".4" />
          <stop offset="100%" stopColor="#0D2818" stopOpacity="0" />
        </linearGradient>
      </defs>
      <rect width="1440" height="240" fill="#0D2818" />
      <path d="M0,0 L0,180 Q240,240 480,170 Q720,100 960,160 Q1200,220 1440,120 L1440,0Z" fill="url(#w6g1)" />
      <path d="M0,0 L0,130 Q360,210 720,120 Q1080,30 1440,100 L1440,0Z" fill="#FAF8F4" opacity=".5" />
      <path d="M0,0 L0,80 Q480,170 960,60 Q1200,-10 1440,50 L1440,0Z" fill="#FAF8F4" opacity=".25" />
      <path d="M0,100 Q200,160 400,90 Q600,20 800,80 Q1000,140 1200,60 Q1400,-10 1440,40" fill="none" stroke="rgba(82,183,136,.08)" strokeWidth="2" />
    </svg>
  ),
};

export const waveBackgrounds = {
  'dark-to-light': 'var(--forest-deep)',
  'light-to-sand': 'var(--cream)',
  'sand-to-light': 'var(--sand-light)',
  'light-to-dark': 'var(--cream)',
  'dark-to-sand': 'var(--forest-deep)',
  'sand-to-dark': 'var(--sand-light)',
};

export const waveSvgHeights = {
  default: 160,
  tall: 200,
  xl: 260,
};
